import {http} from "http/index";
import qs from "utils/query";

import {formatList} from "./formatters";

export const getRequests = async type =>
  http
    .get(`/agent/right-to-rent-request/${qs.stringify(type)}`)
    .then(requests => formatList(requests));
